// src/sot/primitives/ListGroup.jsx
import React from "react";
import Card from "@/components/ui/Card.jsx";

/**
 * ListGroup — SSOT card container for rows
 * - No external margins/padding; width is inherited from <Page/>
 * - BorderLESS + subtle top shadow to match cards elsewhere
 */
export default function ListGroup({ children, className = "" }) {
  return (
    <Card
      as="section"
      className={[
        "w-full overflow-hidden",
        className,
      ].join(" ")}
    >
      {children}
    </Card>
  );
}
